import { supabase } from "@/integrations/supabase/client";

export interface InviteDetails {
  email: string;
  role: string;
  organizationName: string;
  organizationDomain?: string;
  expiresAt: string;
  isValid: boolean;
  isExpired: boolean;
  status: string;
}

export const getInviteDetailsFromToken = async (token: string): Promise<InviteDetails | null> => {
  try {
    const { data, error } = await supabase.functions.invoke("get-invite-details", {
      body: { inviteToken: token },
    });

    if (error || data.error) {
      console.error("Error fetching invite details:", error || data.error);
      return null;
    }

    return data.invite;
  } catch (error) {
    console.error("Error fetching invite details:", error);
    return null;
  }
};

export const acceptInviteToken = async (token: string, userAuthId?: string) => {
  try {
    const { data, error } = await supabase.functions.invoke("accept-organization-invite", {
      body: {
        inviteToken: token,
        userAuthId,
      },
    });

    if (error) {
      throw error;
    }

    if (data.error) {
      throw new Error(data.error);
    }

    return data;
  } catch (error) {
    console.error("Error accepting invite:", error);
    throw error;
  }
};

export const extractInviteTokenFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("invite") || urlParams.get("token");
};
